import { render, staticRenderFns } from "./name-generator.vue?vue&type=template&id=5f6c49bc&scoped=true&"
import script from "./name-generator.vue?vue&type=script&lang=js&"
export * from "./name-generator.vue?vue&type=script&lang=js&"
import style0 from "./name-generator.vue?vue&type=style&index=0&id=5f6c49bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c49bc",
  null
  
)

export default component.exports